(function ($) {
    "use strict";

    const filterPlaces = () => {
        const selectedCategory = $(`.js-filter-button.active`).data('term');
        const searchTerm = $.normalizeString($('#js-search').val());
        const locationSelect = $('.js-location-select option:selected');
        var searchLat = locationSelect.data('lat');
        var searchLng = locationSelect.data('lng');
        const searchRadius = 15; // 15 km radius

        let cardsToShow = 0;

        $('.js-card-nominee').each((i, card) => {
            let type = $(card).data('terms');
            var cardLat = $(card).data('lat');
            var cardLng = $(card).data('lng');

            if (!type) {
                $(card).addClass('d-none');
                return;
            }

            type = String(type).split(",");
            const name = $(card).find('.js-place-name');
            const address = $(card).find('.nominee__address'); // Find the address element

            if (searchTerm.length) {
                const normalizedName = name.length ? $.normalizeString(name.text()) : '';
                const normalizedAddress = address.length ? $.normalizeString(address.text()) : '';

                if (!name.length && !address.length) {
                    $(card).addClass('d-none');
                    return;
                }

                if (!normalizedName.includes(searchTerm) && !normalizedAddress.includes(searchTerm)) {
                    $(card).addClass('d-none');
                    return;
                }
            }

            if (selectedCategory !== 'all' && !type.includes(String(selectedCategory))) {
                $(card).addClass('d-none');
                return;
            }

            if (searchLat !== '' && searchLng !== '' && !isNaN(searchLat) && !isNaN(searchLng)) {
                const distance = $.calculateDistance(searchLat, searchLng, cardLat, cardLng);
                if (cardLat == undefined || cardLng == undefined) {
                    $(card).addClass('d-none');
                    return;
                }
                if (distance > searchRadius) {
                    $(card).addClass('d-none');
                    return;
                }
            }

            cardsToShow++;
            $(card).removeClass('d-none');
        });

        $.filterMarkerPlaces(selectedCategory, searchTerm, searchLat, searchLng, searchRadius);

        if (cardsToShow === 0) {
            $('.js-no-result').show();
        } else {
            $('.js-no-result').hide();
        }
    };

    $(function () {
        if ($(".template--archive-nominee").length === 0) {
            return;
        }

        filterPlaces();
        $('.js-location-select').SumoSelect({ search: true, searchText: 'Keresés' });
        function insertUrlParam(key, value) {
            if (history.pushState) {
                let searchParams = new URLSearchParams(window.location.search);
                searchParams.set(key, value);
                let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
                window.history.pushState({ path: newurl }, '', newurl);
            }
        }

        $('.js-filter-button').on('click', (e) => {
            const button = $(e.currentTarget);

            if (button.hasClass('active')) {
                return;
            }

            $('.js-filter-button.active').removeClass('active');
            button.addClass('active');
            insertUrlParam('c', $(button).data('term'));
            filterPlaces();
        });

        function debounce(func, timeout = 500) {
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => { func.apply(this, args); }, timeout);
            };
        }

        const processChange = debounce(() => {
            const searchTerm = $('#js-search').val();
            insertUrlParam('s', searchTerm);
            filterPlaces();
        });

        $('#js-search').on('input', function (e) {
            processChange();
        });

        $('.js-location-select').on('change', function (e) {
            const selectedLocation = $(this).val();
            insertUrlParam('loc', selectedLocation);
            filterPlaces();
        });
    });
})(jQuery);


